import type { FieldValues } from 'react-hook-form';
import clsx from 'clsx';
import { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { FormSectionConfig, HookFormProps } from './types';

interface FormSectionProps<FormValues extends FieldValues>
  extends HookFormProps<FormValues>,
    Omit<FormSectionConfig<FormValues>, 'type' | 'rows' | 'children'> {
  children?: ReactNode;
}

export const FormSectionBlock = <FormValues extends FieldValues>({
  watch,
  children,
  variant = 'default',
  ...section
}: FormSectionProps<FormValues>): ReactElement | null => {
  const { t } = useTranslation();
  if (
    watch &&
    section.isHiddenValidation &&
    section.isHiddenValidation(watch())
  ) {
    return null;
  }
  return (
    <div
      data-testid={`schedule-form-section-${section.title}`}
      className={clsx('flex w-full flex-col gap-4', {
        'rounded-sm bg-gray-50 px-4 pb-5 pt-3': variant === 'secondary',
      })}
    >
      {section.title && (
        <h2 className={'pb-4 text-body-medium-semibold'}>{t(section.title)}</h2>
      )}
      {children}
    </div>
  );
};
